import { useQuery } from '@tanstack/react-query';

import { createOrderV2Client } from '../api/client';
import { orderV2QueryKeys } from '../api/queryKeys';
import { UniformListItem } from '../api/types';

const useUniforms = (billingAccountId: number | null) => {
  const enabled = billingAccountId != null;
  const query = useQuery<UniformListItem[]>({
    queryKey: enabled
      ? orderV2QueryKeys.uniforms(billingAccountId)
      : ['orders_v2', 'uniforms', 'disabled'],
    queryFn: () =>
      createOrderV2Client
        .listUniforms(billingAccountId as number)
        .then((result) => result || []),
    enabled,
  });

  return {
    uniforms: query.data ?? [],
    uniformsLoading: enabled && query.isFetching,
    uniformsError: query.error
      ? (query.error as Error).message || 'Failed to load uniforms'
      : null,
  };
};

export default useUniforms;
